import {Component, forwardRef, Injector, ChangeDetectorRef, Input} from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
import { AbstractWorkflowFormComponent } from '../../@core/abstract-workflow-form-component';
import { DatasourceDatasSelectionModel } from '../datasource-datas-selection.model';
import { DatasourceDatasSelectionDialogComponent } from '../datasource-datas-selection-dialog/datasource-datas-selection-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { WorkflowComponentsService } from '../../workflow-components.service';
import { DatasourceService } from 'src/app/core-api/services/datasource/datasource.service';
import { ABW_MAT_DATATABLE_VIEWMODE } from 'src/app/shared/abw-mat-datatable/abw-mat-datatable.component';

@Component({
    selector: 'abw-datasource-datas-selection-form',
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => DatasourceDatasSelectionFormComponent),
        multi: true
      },
      {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => DatasourceDatasSelectionFormComponent),
        multi: true
      }
    ],
    templateUrl: './datasource-datas-selection-form.component.html',
    styleUrls: ['./datasource-datas-selection-form.component.scss']
})
export class DatasourceDatasSelectionFormComponent extends AbstractWorkflowFormComponent<DatasourceDatasSelectionModel, string> {
    @Input() datas: any;
    @Input() selection: any;
    @Input() primaryKey: any;
    @Input() datatableViewMode = ABW_MAT_DATATABLE_VIEWMODE.READONLY;

    constructor(
		protected inj: Injector,
        protected _workflowComponentsService: WorkflowComponentsService,
        protected _cdf: ChangeDetectorRef,
        private dialog: MatDialog,
    ) {
        super(_workflowComponentsService, _cdf, inj);
    }

    async openDialog() {
        const dialogRef = this.dialog.open(DatasourceDatasSelectionDialogComponent, {
            data: { 
                datasource: this.datas,
                selection: this.selection,
                primaryKey: this.primaryKey,
                datatableViewMode: this.datatableViewMode,
                label: 'Selection de données'
            },
            width: '95vw',
            panelClass: 'datasource-designer-modal'
        });
    
        dialogRef.afterClosed().subscribe((selection?: any) => {
            if (selection === undefined) { return; }
            this.onValueChanged(selection);
        });
    }
}